<!------ Templates ------->
<ui-dialog
    [open]="!!showAdminNote"
    (closing)="showAdminNote = null"
    header="{{ 'account.benefits.planAdministratorsNote' | translate }}"
    primaryButtonLabel="{{ 'account.benefits.close' | translate }}"
    (primaryButtonPressed)="showAdminNote = null"
>
    {{ showAdminNote }}
</ui-dialog>

<!-- Change Request Status Acknowledgements -->
<div *ngFor="let changeRequest of allChangeRequests; let i = index">
    <ng-container *ngIf="changeRequest">
        <!-- Status:: Draft -->
        <ng-container *ngIf="changeRequest.status === changeRequestStatuses.draft">
            <ui-card>
                <app-segment-header
                    title="{{ 'account.benefits.changeRequest' | translate }}"
                    [badgeOptions]="changeRequestStatusBadgeOptions"
                >
                </app-segment-header>

                <p>
                    {{
                        'account.benefits.changeRequestIsDraft'
                            | translate: { date: changeRequest.submittedAt | appDate }
                    }}
                </p>
            </ui-card>
        </ng-container>

        <!-- Status:: Pending -->
        <ng-container *ngIf="changeRequest.status === changeRequestStatuses.pending">
            <ui-card>
                <app-segment-header
                    title="{{ 'account.benefits.changeRequest' | translate }}"
                    [badgeOptions]="changeRequestStatusBadgeOptions"
                >
                    <!-- Edit & Delete button -->
                    <div class="buttons">
                        <ui-button type="link" (click)="onDeleteChangeRequest(changeRequest)">{{
                            'delete' | translate
                        }}</ui-button>
                    </div>
                </app-segment-header>

                <p>
                    {{
                        'account.benefits.changeRequestIsPending'
                            | translate: { date: changeRequest.submittedAt | appDate }
                    }}
                </p>
            </ui-card>
        </ng-container>

        <!-- Status:: Declined -->
        <div *ngIf="changeRequest.status === changeRequestStatuses.declined" class="padding-bottom-2">
            <ui-banner variant="info" [closable]="true" (close)="acknowledge(changeRequest)">
                <p>
                    {{
                        'account.benefits.changeRequestDenied'
                            | translate: { date: changeRequest.submittedAt | appDate }
                    }}
                    <ng-container *ngIf="changeRequest.adminNotes">
                        <a class="show-note" (click)="showAdminNote = changeRequest.adminNotes">{{
                            'account.benefits.clickHere' | translate
                        }}</a>
                        {{ 'account.benefits.toViewPlanAdminsNote' | translate }}
                    </ng-container>
                </p>
            </ui-banner>
        </div>

        <!-- Status:: Approved -->
        <div *ngIf="changeRequest.status === changeRequestStatuses.approved" class="padding-bottom-2">
            <ui-banner variant="info" [closable]="true" (close)="acknowledge(changeRequest)">
                <p>
                    {{
                        'account.benefits.changeRequestWasApproved'
                            | translate: { date: changeRequest.submittedAt | appDate }
                    }}
                    <ng-container *ngIf="changeRequest.adminNotes">
                        <a class="show-note" (click)="showAdminNote = changeRequest.adminNotes">{{
                            'account.benefits.clickHere' | translate
                        }}</a>
                        {{ 'account.benefits.toViewPlanAdminsNote' | translate }}
                    </ng-container>
                </p>
            </ui-banner>
        </div>
    </ng-container>
</div>
